import { render } from "./routeSetting.vue?vue&type=template&id=3a18db46"
import script from "./routeSetting.vue?vue&type=script&lang=js"
export * from "./routeSetting.vue?vue&type=script&lang=js"

import "./routeSetting.vue?vue&type=style&index=0&id=3a18db46&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__